function formatEmail(email) {
    if (email === undefined || email == null) return ""
    return email.replace(/[\u200A\u200B\u200C\u200E\u200F\u200D]/g, "")
}

export default formatEmail;
